import { AppointmentModal } from '@features/appointment/appointment'
import { CalendarSyncModal } from '@features/calendar-sync'
import { AttachFileModal } from '@features/attach-files'
import { SlotOfferModal, PackageOfferModal } from '@features/messanger/send-offer'
import { RemoveAppointmentModal } from '@features/appointment/remove-appointment'
import { TimezoneModal } from '@features/profile/timezone'
import { VacationModal } from '@features/profile/vacation'
import { ScheduleModal } from '@features/schedule/schedule-modal'
import { CancelOrderModal } from '@features/student/cancel-order'
import { OrderModal } from '@features/student/order/ui/order-modal/order-modal'
import { TeacherModal } from '@features/student/teacher'
import { StudentModal } from '@features/teacher/student/ui/student-modal/student-modal'
import { AddAppointmentByTeacherModal } from '@features/teacher/add-appointment-by-teacher'
import { StudentsListModal } from '@widgets/teacher/ui/students-list-modal'
import { AddReviewModal } from '@features/student/add-review'
import React from 'react'

export const SharedModals = () => <>
	<CalendarSyncModal/>
	<TimezoneModal/>
	<VacationModal/>
	<AppointmentModal/>
	<RemoveAppointmentModal/>
	<StudentModal/>
	<TeacherModal/>
	<OrderModal/>
	<CancelOrderModal/>
	<ScheduleModal/>
	<AddAppointmentByTeacherModal/>
	<StudentsListModal/>
	<AttachFileModal/>
	<SlotOfferModal/>
	<PackageOfferModal/>
	<AddReviewModal/>
</>
